import React from "react";
//#region types
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

interface AgentQuestionCardProps {
  text: string;
  files: UploadedFile[];
  choice?: string;
}

const t = LocalizationHelperInstance.getFormattedMessage;

const MetaLine: React.FC<{ labelKey: string; value: string }> = ({ labelKey, value }) => (
  <span className={cssExports.agentQuestionMeta}>
    {t(labelKey)} <span className={cssExports.agentQuestionMetaValue}>{value}</span>
  </span>
);

const AgentQuestionCard: React.FC<AgentQuestionCardProps> = ({ text, files, choice }) => (
  <Grid container direction="column" className={cssExports.agentQuestionBlock}>
    <span className={cssExports.agentQuestionLabel}>{t(TranslationKeys.SupportIssue.AgentYourQuestion)}</span>
    <Grid container direction="column" className={cssExports.agentQuestionBox}>
      <span className={cssExports.agentQuestionText}>{text}</span>
      {files.length ? (
        <MetaLine
          labelKey={TranslationKeys.SupportIssue.AgentAttachedLabel}
          value={files.map((file) => file.fileName).join(", ")}
        />
      ) : null}
      {choice ? <MetaLine labelKey={TranslationKeys.SupportIssue.AgentAdditionLabel} value={choice} /> : null}
    </Grid>
  </Grid>
);

export default AgentQuestionCard;
